import React, { forwardRef, useRef, useEffect, useState } from 'react';
import $ from 'jquery';

interface Props {
    src: string;
};

const Video = forwardRef<HTMLDivElement, Props>(({
    src = '',
}, ref: any) => {

    const nodeRef = useRef<any>(null);
    const videoRef = useRef<any>(null);
    const [ isPlaying, setIsPlaying ] = useState(false);

    const rebind = () => {
	unbind();

	const video = $(videoRef.current);

	video.on('play', () => onPlay());
	video.on('pause', () => onPause());
    };

    const unbind = () => {
	$(videoRef.current).off('play');
    };

    const onPlay = () => {
	const node = $(nodeRef.current);

	if (videoRef.current) {
	    videoRef.current.controls = true;
	};

	setIsPlaying(true);
	node
	    .removeClass('isPaused')
	    .addClass('isPlaying');
    };

    const onPause = () => {
	const node = $(nodeRef.current);

	setIsPlaying(false);
	node.addClass('isPaused');
    };

    const onClick = (e: any) => {
	e.preventDefault();
	e.stopPropagation();

	if (isPlaying) {
	    videoRef.current?.pause();
	} else {
	    videoRef.current?.play();
	};
    };

    useEffect(() => {
	rebind();
	return () => unbind();
    });

    return (
	<div ref={nodeRef} className="videoWrapper" onClick={onClick}>
	    <div className="caption">
		<div className="img" />
		<span>A quick tour from our founder</span>
	    </div>

	    <div className="plug" />

	    <div className="play">
		<div className="icon" />
	    </div>

	    <video ref={videoRef} className="media" controls={false} preload="auto" src={src} />
	</div>
    );
});

export default Video;